module.exports = __webpack_public_path__ + "img/grinning-face-with-sweat.f1cdaa1f.png";